import React, { useEffect, useState } from "react";
import "./Users.scss";

import { FaChevronRight } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import { IoSearch } from "react-icons/io5";

import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader/Loader";
import { fetchUsersByOrganization } from "../../api/userManagement";
import { useSelector } from "react-redux";
import ROUTES from "../../constants/routes";
import { IoIosArrowBack } from "react-icons/io";

import AddUser from "./AddUser/AddUser";
import { useViewPortDetector } from "../../helpers/viewPortDetector";
import CreatePassword from "./AddUser/CreatePassword/CreatePassword";
import UserBranches from "./UserBranches/UserBranches";

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const Users = () => {
  const { id: organization_id } = useSelector(
    (state) => state.organizationReducer.value
  );

  const navigate = useNavigate();

  const { currentViewPort } = useViewPortDetector();

  const [loading, setLoading] = useState(true);
  const [users, setUsers] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);

  const [selectedDesktopTag, setSelectedDesktopTag] = useState("Add User");

  const getUsers = () => {
    setLoading(true);

    fetchUsersByOrganization(organization_id, keyword)
      .then((res) => {
        if (res.data?.length > 0) {
          setUsers(res.data);
        } else {
          setUsers([]);
        }
        setSelectedUser(null);
        setSelectedDesktopTag("Add User");
      })
      .catch((err) => {
        console.log("Error while fetching users.", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getUsers();
  }, [keyword, organization_id]);

  const editUserArray = (data) => {
    const alreadyExists = users?.find((el) => el?.id && el?.id === data?.id);

    if (alreadyExists) {
      setUsers((prev) => {
        const newCustomers = prev?.map((cos) =>
          cos?.id && cos?.id === data?.id ? { ...cos, ...data } : cos
        );
        return newCustomers;
      });
      setSelectedUser(data);
      setSelectedDesktopTag("User Details");
    } else if (data?.id) {
      setUsers((prev) => [...prev, data]);
      setSelectedDesktopTag("Add User");
      setSelectedUser(null);
    }
  };

  const removeUserArray = (data) => {
    setUsers((prev) => {
      const newCustomers = prev?.filter((cos) => cos?.id !== data?.id);
      return newCustomers;
    });
    setSelectedUser(null);
    setSelectedDesktopTag("Add User");
  };
  return (
    <>
      {loading && <Loader />}
      <div className="page-with-side-components">
        <div className="users-page">
          <div className="desktop-navbar box-shadow">
            <p>{ROUTES.manageUser.title}</p>
            <div
              className="last-tag-svg"
              onClick={() => {
                setSelectedUser(null);
                setSelectedDesktopTag("Add User");
                navigate("#", { state: {} });
              }}
            >
              <FaPlus />
            </div>
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              setKeyword(e.target.keyword.value);
            }}
            className="user-search"
          >
            <div className="inputs">
              <input
                type="text"
                name="keyword"
                placeholder="Search by name or email."
              />
              <button type="submit">
                <IoSearch />
              </button>
            </div>
          </form>

          <div className="user-lists container-wrapper">
            {!users?.length && <p className="no-users">No users found.</p>}
            {users?.map((item, i) => {
              const image = item?.image ? `${IMAGE_URL}${item?.image}` : null;

              const userNames = `${item?.name}`.split(" ");

              const userInitials =
                `${item?.name}`.length >= 0
                  ? `${`${item?.name}`[0]}${
                      userNames.length > 1
                        ? `${userNames[1]}`.length >= 0
                          ? `${userNames[1]}`[0]
                          : ""
                        : ""
                    }`
                  : "";
              return (
                <div
                  className={`item ${
                    selectedUser === item ? "highlight-selected-item" : ""
                  }`}
                  key={i}
                  onClick={() => {
                    if (currentViewPort === "mobile") {
                      navigate(ROUTES.manageUserBranches.path, {
                        state: { userData: item },
                      });
                    } else {
                      setSelectedUser(item);
                      setSelectedDesktopTag("User Details");
                    }
                  }}
                >
                  <div className="left">
                    <div
                      className="image"
                      style={image ? { backgroundImage: `url(${image})` } : {}}
                    >
                      {!image && <p>{userInitials}</p>}
                    </div>

                    <div className="content">
                      <p className="name">{item?.name}</p>
                      <p className="phone">{item?.email}</p>
                    </div>
                  </div>

                  <div className="right">
                    <p>{item?.is_admin ? "Admin" : ""}</p>
                    <FaChevronRight />
                  </div>
                </div>
              );
            })}
          </div>

          <div className="add-user-icon">
            <FaPlus
              onClick={() => {
                navigate(ROUTES.addUser.path);
              }}
            />
          </div>
        </div>

        <div className="right-desktop-view p-relative">
          <div
            className={`desktop-navbar ${
              selectedDesktopTag === "User Details"
                ? ""
                : "border-bottom box-shadow"
            }`}
          >
            {selectedDesktopTag !== "Add User" && (
              <div
                className="back"
                onClick={() => {
                  if (
                    selectedDesktopTag === "Edit User" ||
                    selectedDesktopTag === "Reset Password"
                  ) {
                    setSelectedDesktopTag("User Details");
                  } else {
                    setSelectedDesktopTag("Add User");
                    setSelectedUser(null);
                  }
                }}
              >
                <IoIosArrowBack />
              </div>
            )}
            <p>{selectedDesktopTag}</p>
          </div>

          {selectedDesktopTag === "Add User" && (
            <AddUser
              desktopView={true}
              setSelectedDesktopTag={setSelectedDesktopTag}
              isAdd={true}
            />
          )}
          {selectedDesktopTag === "Edit User" && (
            <AddUser
              isEdit={true}
              selected={selectedUser}
              desktopView={true}
              reload={(data) => editUserArray(data)}
            />
          )}
          {selectedDesktopTag === "Set Password" && (
            <CreatePassword
              desktopView={true}
              reload={(data) => editUserArray(data)}
            />
          )}

          {selectedDesktopTag === "Reset Password" && (
            <CreatePassword
              desktopView={true}
              setSelectedDesktopTag={setSelectedDesktopTag}
            />
          )}

          {selectedDesktopTag === "User Details" && (
            <UserBranches
              desktopView={true}
              selected={selectedUser}
              setSelectedDesktopTag={setSelectedDesktopTag}
              reload={(data) => {
                editUserArray(data);
              }}
              replace={(data) => {
                removeUserArray(data);
              }}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Users;
